<div class="form-group">
  <ng-content></ng-content>
  <!-- For template-driven forms -->
  <ng-container *ngIf="mainAccessor?.invalid && mainAccessor?.touched && displayErrors">
    <div class="invalid-feedback">
      Please provide a valid {{label ? label : 'value'}}
    </div>
  </ng-container>

  <ng-container>
    <div class="pw-requirements margin-top-20"  [ngClass]="validityChecked ? 'pw-req-dirty' : ''">
      <div style="width: 50%">
        <ul class="list-unstyled">
          <li [ngClass]="oneLcValid ? 'req-valid' : 'req-invalid'">
            <ng-container [ngTemplateOutlet]="tplIcon" [ngTemplateOutletContext]="{isValid: oneLcValid}"></ng-container>
            One lowercase character
          </li>
          <li [ngClass]="oneUcValid ? 'req-valid' : 'req-invalid'">
            <ng-container [ngTemplateOutlet]="tplIcon" [ngTemplateOutletContext]="{isValid: oneUcValid}"></ng-container>
            One uppercase character
          </li>
          <li *ngIf="!maxCharsValid" class="max-char-invalid">
            <i class="fa fa-warning"></i> {{maxChars}} characters maximum
          </li>
          <li [ngClass]="oneNumValid ? 'req-valid' : 'req-invalid'">
            <ng-container
              [ngTemplateOutlet]="tplIcon"
              [ngTemplateOutletContext]="{isValid: oneNumValid}">
            </ng-container>
            One number
          </li>
          <li [ngClass]="minCharsValid ? 'req-valid' : 'req-invalid'">
            <ng-container
              [ngTemplateOutlet]="tplIcon"
              [ngTemplateOutletContext]="{isValid: minCharsValid}">
            </ng-container>
            {{minChars}} characters minimum
          </li>
          <li *ngIf="!noSpecialValid" class="max-char-invalid">
            <i class="fa fa-warning"></i> Special characters not allowed
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #tplIcon let-isValid="isValid">
  <i class="fa fa-check" *ngIf="isValid"></i>
  <i class="fa fa-warning" *ngIf="!isValid && validityChecked"></i>
  <i class="fa fa-exclamation-circle" *ngIf="!isValid && !validityChecked"></i>
</ng-template>
